<template>
  <div class="city-manager-list">
    <div class="toolbar">
      <Button color="primary" @click="add">新增</Button>
    </div>
    <Table :datas="datas" :border="true">
      <TableItem title="序号" :width="80" align="center">
        <template v-slot="{ index }">{{ index + 1 }}</template>
      </TableItem>
      <TableItem title="城市经理名称" prop="name"></TableItem>
      <TableItem title="操作" :width="150" align="center">
        <div class="actions" slot-scope="{ data }">
          <span @click="edit(data)">编辑</span>
          <span @click="remove(data)">删除</span>
        </div>
      </TableItem>
    </Table>
    <Modal v-model="showForm" hasCloseIcon type="drawer-right">
      <div slot="header">{{ form.id ? '编辑城市经理' : '新增城市经理' }}</div>
      <Form ref="form" v-width="400" :labelWidth="100" :model="form" :rules="validationRules">
        <FormItem label="名称" prop="name">
          <input type="text" v-model="form.name" placeholder="请输入城市经理名称">
        </FormItem>
      </Form>
      <div class="text-center">
        <Button color="green" @click="submit" :loading="loading">{{ form.id ? '更新' : '保存' }}</Button>
        <Button @click="showForm = false" :disabled="loading">取消</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
const emptyForm = {
  "name": ""
};
	/**
	 * 城市经理 - 「城市经理」标签页
	 * 占位页面，具体表格/表单/接口后续实现
	 */
	export default {
		name: "CityManagerList",
    data() {
      return {
        datas: [],
        form: Object.assign({}, emptyForm),
        validationRules: {
          required: ["name"]
        },
        showForm: false,
        loading: false
      };
    },
    watch: {
      // 弹窗关闭后重置表单，避免下次打开残留上一次的数据
      showForm(val) {
        if (!val) {
          this.reset();
        }
      }
    },
    methods: {
      loadList() {
        this.$api.report.jingLi.list().then(({data}) => {
          this.datas = data || [];
        });
      },
      add() {
        this.form = Object.assign({}, emptyForm);
        this.showForm = true;
      },
      edit(data) {
        this.form = Object.assign({}, data);
        this.showForm = true;
      },
      submit() {
        let validResult = this.$refs.form.valid();
        if (validResult.result) {
          // 名称查重：与列表中已有名称比对，编辑时排除自身记录
          const name = (this.form.name || '').trim();
          const duplicated = this.datas.some(item => item.name === name && item.id !== this.form.id);
          if (duplicated) {
            this.$Message.error('城市经理名称已存在，请勿重复添加');
            return;
          }
          this.loading = true;
          this.$api.report.jingLi[this.form.id ? 'update' : 'save'](this.form).then(() => {
            this.$Message.success(this.form.id ? '更新成功' : '保存成功');
            this.loadList();
            this.showForm = false;
            this.loading = false;
          }).catch(() => {
            this.loading = false;
          });
        }
      },
      remove(data) {
        // 删除前校验：该城市经理是否已被部门归属，已归属则不允许删除
        this.isJingLiUsed(data.id).then(used => {
          if (used) {
            this.$Message.error('该城市经理已归属部门，不能删除，请先在「部门归属」中解除关联');
            return;
          }
          this.$Confirm("确认删除?").then(() => {
            this.$api.report.jingLi.delete(data.id).then(() => {
              this.$Message.success('删除成功');
              this.loadList();
            });
          });
        });
      },
      /**
       * 检查指定城市经理是否已被部门归属（部门的 cusColumn15 引用了该经理 ID）
       * @param {Number|String} jingLiId 城市经理 ID
       * @returns {Promise<boolean>} 已被归属返回 true，否则返回 false
       */
      async isJingLiUsed(jingLiId) {
        // 获取全部辅助核算类别，找到"部门"类别
        const {data: categories} = await this.$api.setting.accountingCategory.list();
        const department = (categories || []).find(item => item.name === '部门');
        if (!department) return false;
        // 获取部门明细，检查 cusColumn15 是否包含该城市经理 ID
        const {data: detail} = await this.$api.setting.accountingCategoryDetails.list(department.id);
        const records = detail.records || [];
        return records.some(dep => {
          const val = dep.cusColumn15;
          if (val === undefined || val === null || val === '') return false;
          // 兼容单个 ID、逗号分隔字符串、数组三种存储形式
          const ids = Array.isArray(val) ? val : String(val).split(',');
          return ids.some(id => String(id).trim() === String(jingLiId));
        });
      },
      reset() {
        this.form = Object.assign({}, emptyForm);
      }
    },
    mounted() {
      this.loadList();
    }
	};
</script>
<style lang='less' scoped>
	.city-manager-placeholder {
		.placeholder-tip {
			color: #999999;
			text-align: center;
			padding: 40px 0;
		}
	}
</style>
